import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        originAirportIcon: {
            paddingTop: theme.spacing(2.5),
        },
        circle: {
            width: 14,
            height: 14,
            border: `4px solid ${theme.palette.primary[200]}`,
            borderRadius: '50%',
        },
        iconLocation: {
            width: 22,
        },
    }
})

export default useStyles
